import { render, staticRenderFns } from "./CredentialBrandLockup.vue?vue&type=template&id=48dd2fbf&scoped=true"
import script from "./CredentialBrandLockup.vue?vue&type=script&lang=js"
export * from "./CredentialBrandLockup.vue?vue&type=script&lang=js"
import style0 from "./CredentialBrandLockup.vue?vue&type=style&index=0&id=48dd2fbf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48dd2fbf",
  null
  
)

export default component.exports